import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RESOURCES } from '../app.constants';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';


@Injectable()
/** @desc Service class to handle tag related operations **/
export class TagService {
  constructor(private http: HttpClient) {}

  /**
   * @desc Function to get single tag by tag name
   * @param {string} tagName - Name of the respective tag
   * @return {Observable} A mapped observable with the request result
   */
  getTag(tagName: string): Observable<any> {
    return this.http.put(RESOURCES.TAG + '/' + tagName, {}).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to get tags based on pagination
   * @param {object} paginationParams - Indicator for pagination
   * @return {Observable} A mapped observable with the request result
   */
  getTags(paginationParams?): Observable<any> {
    paginationParams = paginationParams || '';
    return this.http.get(RESOURCES.TAG + paginationParams).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to delete tags based on the id
   * @param {string} id - The id of the tag to be deleted
   * @return {Observable} A mapped observable with the request result
   */
  deleteTags(id: string): Observable<any> {
    return this.http.delete(RESOURCES.TAG + '/' + id).pipe(map(res => <any>res));
  }
}

/**
 * Service function to handle tag tasks
 * @author {andre.pitombeira}
 * @param {$http} $http - Http service function
 * @param {object} RESOURCES - Constant parameter object
 * @return {object} - Service object with functions
 */
export default function tagService($http, RESOURCES) {
  let service;

  service = {
    getTag,
    getTags,
    deleteTags,
  };

  function getTag(tagName) {
    return $http.put(RESOURCES.TAG + '/' + tagName, {});
  }

  function getTags(paginationParams) {
    paginationParams = paginationParams || '';
    return $http.get(RESOURCES.TAG + paginationParams);
  }

  function deleteTags(id) {
    return $http.delete(RESOURCES.TAG + '/' + id);
  }

  return service;
}



// WEBPACK FOOTER //
// ./src/app/tags/tag.service.ts